import { render, staticRenderFns } from "./xszp.vue?vue&type=template&id=cb802984&scoped=true&"
import script from "./xszp.vue?vue&type=script&lang=js&"
export * from "./xszp.vue?vue&type=script&lang=js&"
import style0 from "./xszp.vue?vue&type=style&index=0&id=cb802984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb802984",
  null
  
)

export default component.exports